import { useRef, useState, type FormEvent } from "react";

import {
  FormField,
  InlineMessage,
  MonitorButton,
  MonitorPage,
  PageHeading,
} from "@/components/monitor/MonitorUI";
import { submitFeedback } from "@/lib/api/feedbackApi";
import styles from "./SupportPage.module.scss";

export function SupportPage() {
  const [message, setMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const submitRef = useRef(false);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const trimmedMessage = message.trim();
    if (!trimmedMessage || submitRef.current) return;

    submitRef.current = true;
    setIsSubmitting(true);
    setSuccess(false);
    setError(null);

    try {
      await submitFeedback(trimmedMessage);
      setMessage("");
      setSuccess(true);
    } catch (err) {
      console.error("Support submission error:", err);
      setError("We couldn't send your message. Please try again.");
    } finally {
      submitRef.current = false;
      setIsSubmitting(false);
    }
  };

  return (
    <MonitorPage className={styles.page}>
      <PageHeading
        title="Support"
        description="Tell us what went wrong or what would make GoodBaby better."
      />

      {success ? (
        <InlineMessage tone="success">
          Message sent. Thanks for your feedback.
        </InlineMessage>
      ) : null}
      {error ? <InlineMessage>{error}</InlineMessage> : null}

      <form className={styles.form} onSubmit={handleSubmit}>
        <FormField label="Your message" htmlFor="support-message">
          <textarea
            id="support-message"
            value={message}
            onChange={(event) => {
              setMessage(event.target.value);
              setSuccess(false);
              setError(null);
            }}
            disabled={isSubmitting}
            rows={7}
          />
        </FormField>
        <MonitorButton
          type="submit"
          loading={isSubmitting}
          loadingLabel="Sending…"
          disabled={!message.trim()}
        >
          Send message
        </MonitorButton>
      </form>
    </MonitorPage>
  );
}
